module.exports = __webpack_public_path__ + "static/img/stayInControl.2cf2c2a2.png";